// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2849 ? "thewasim" : chunkId) + "." + {"2849":"89867dd0","3630":"4b058fd6","7873":"24565726"}[chunkId] + ".chunk.css";
};